import { render, staticRenderFns } from "./PostExchangeDifferences.vue?vue&type=template&id=77453b82&"
import script from "./PostExchangeDifferences.vue?vue&type=script&lang=js&"
export * from "./PostExchangeDifferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports